export function state(initialState) {
  return {
    contentTags: false
  };
}
